import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { registerServiceWorker } from './lib/serviceWorker';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('No #root element in index.html');

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);

// Offline shell and Add to Home Screen. See public/sw.js.
registerServiceWorker();
